import React from 'react';

const FormKey = (): JSX.Element => {
    return <input type="hidden" name="form_key" value={window.form_key} />;
};

export default FormKey;
